const Arrow = ({fill}) => (
  <svg width="14px" height="26px" viewBox="0 0 14 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <polygon fill={fill} fillRule="nonzero" points="13.3023811 24.6464466 12.5952743 25.3535534 0.292893219 13.0511723 12.6976189 0.646446609 13.4047257 1.35355339 1.70710678 13.0511723"></polygon>
  </svg>
)

export default Arrow



// WEBPACK FOOTER //
// ./app/javascript/packs/svg/Arrow.js